'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$StatItem(value, label) {
  this.iB = null;
  this.iA = null;
  this.iB = value;
  this.iA = label;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$StatItem as $c_Lio_intela_sites_digitalinternship_data_Segments$StatItem };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$StatItem.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$StatItem;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$StatItem() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$StatItem as $h_Lio_intela_sites_digitalinternship_data_Segments$StatItem };
$h_Lio_intela_sites_digitalinternship_data_Segments$StatItem.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-1828969261), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$StatItem) && ((this.iB === x$0.iB) && (this.iA === x$0.iA))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "StatItem";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.iB;
  }
  if ((n === 1)) {
    return this.iA;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$StatItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bJ)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$StatItem as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$StatItem };
var $d_Lio_intela_sites_digitalinternship_data_Segments$StatItem = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$StatItem, "io.intela.sites.digitalinternship.data.Segments$StatItem", ({
  bJ: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$StatItem as $d_Lio_intela_sites_digitalinternship_data_Segments$StatItem };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Stat-Item.js.map
